<template>
    <div>
        <div class="relative md:rounded-2xl rounded-none overflow-hidden shadow-[0_4px_12px_rgba(0,0,0,0.03)] border-y md:border-x border-gray-100" v-if="$app.userInfo">
            <!-- Thanh cuộn ngang tùy chỉnh cho màn hình nhỏ / Synced Top Horizontal Scrollbar Bar -->
            <div v-if="hasHorizontalOverflow" class="sticky top-0 z-20 bg-gray-50/95 backdrop-blur border-b border-gray-200 px-3 py-2 flex items-center justify-between gap-3 shadow-xs select-none">
                <div class="flex items-center gap-2 text-xs font-semibold text-gray-700 shrink-0">
                    <font-awesome-icon :icon="['fas', 'arrows-left-right']" class="text-brand text-sm" />
                    <span class="hidden sm:inline">Thanh cuộn ngang:</span>
                </div>
                
                <div class="flex-1 flex items-center gap-2 min-w-0">
                    <button 
                        type="button" 
                        @click="scrollTableLeft" 
                        class="p-1 px-2.5 text-xs font-bold bg-white text-gray-700 hover:text-brand hover:bg-brand/10 border border-gray-200 rounded-md shadow-xs transition-all flex items-center gap-1 shrink-0 active:scale-95 cursor-pointer"
                        title="Cuộn sang trái"
                    >
                        <font-awesome-icon :icon="['fas', 'chevron-left']" />
                    </button>

                    <!-- Slider thanh cuộn tương tác -->
                    <div class="relative flex-1 flex items-center h-6 px-1">
                        <input 
                            type="range" 
                            min="0" 
                            :max="maxScrollLeft" 
                            v-model.number="currentScrollLeft" 
                            @input="onSliderInput"
                            class="table-scroll-slider w-full cursor-pointer h-2 bg-gray-200 rounded-lg appearance-none outline-none accent-brand"
                        />
                    </div>

                    <button 
                        type="button" 
                        @click="scrollTableRight" 
                        class="p-1 px-2.5 text-xs font-bold bg-white text-gray-700 hover:text-brand hover:bg-brand/10 border border-gray-200 rounded-md shadow-xs transition-all flex items-center gap-1 shrink-0 active:scale-95 cursor-pointer"
                        title="Cuộn sang phải"
                    >
                        <font-awesome-icon :icon="['fas', 'chevron-right']" />
                    </button>
                </div>
            </div>

            <el-table :data="$app.listBill" style="width: 100%" highlight-current-row
                header-row-class-name="custom-row-head" header-cell-class-name="custom-cell-head"
                @row-click="onRowClick" :expand-row-keys="[expandedRow]" row-key="id" v-loading="!loading"
                element-loading-text="Đang tải dữ liệu..." element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" @selection-change="handleSelectionChange"
                :row-class-name="tableRowClassName" @filter-change="handleFilterChange">
                <el-table-column type="expand" class-name="expand-col" width="1">
                    <template #default="{ row }">
                        <div class="p-4 md:p-6 bg-gray-50/50 md:rounded-xl md:m-2 my-2 mx-0 border border-brand/10 shadow-[inset_0_2px_10px_rgba(2,75,179,0.02)] w-[100vw] md:w-auto md:max-w-none sticky left-0 md:static">
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 text-sm pb-4">
                                <div class="bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                                    <div class="flex items-center gap-2 mb-3"><div class="w-1 h-4 bg-brand rounded-full"></div><span class="font-semibold text-gray-800">Thông tin chung</span></div>
                                    <p class="my-2 flex justify-between gap-2"><span class="text-gray-500 shrink-0">Mã phiếu:</span> <span class="font-medium text-gray-900 text-right break-words max-w-[65%]">{{ row.code }}</span></p>
                                    <p class="my-2 flex justify-between gap-2"><span class="text-gray-500 shrink-0">Loại phiếu:</span> <span class="font-medium text-gray-900 text-right break-words max-w-[65%]">{{ checkformBill(row.billType).label }}</span></p>
                                    <p class="my-2 flex justify-between gap-2"><span class="text-gray-500 shrink-0">Bộ phận:</span> <span class="font-medium text-gray-900 text-right break-words max-w-[65%]">{{ row.departments[0].name }}</span></p>
                                    <p class="my-2 flex justify-between gap-2"><span class="text-gray-500 shrink-0">Tổng tiền:</span> <span class="font-bold text-brand text-right break-words max-w-[65%]">{{ formatVND(row.expense) }}</span></p>
                                </div>
                                <div class="bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                                    <div class="flex items-center gap-2 mb-3"><div class="w-1 h-4 bg-brand rounded-full"></div><span class="font-semibold text-gray-800">Chi tiết thanh toán</span></div>
                                    <p class="my-2 flex justify-between gap-2 items-center"><span class="text-gray-500 shrink-0">PTTT:</span> 
                                        <span class="font-medium text-gray-900 text-right break-words max-w-[65%]">{{ checkPaymentMethod(row.paymentMethod).label }}</span>
                                    </p>
                                    <p class="my-2 flex justify-between gap-2"><span class="text-gray-500 shrink-0">Ngày tạo:</span> <span class="font-medium text-gray-900 text-right break-words max-w-[65%]">{{ formatDate(row.paytime) }}</span></p>
                                    <p class="my-2 flex justify-between gap-2 items-center"><span class="text-gray-500 shrink-0">Người tạo:</span> <el-tag size="small" effect="plain" class="rounded-lg border-brand/20 text-brand bg-brand/5 !whitespace-normal h-auto py-1 text-right break-words max-w-[65%]">{{ row.authuserslog.name }}</el-tag></p>
                                </div>
                                <div class="bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                                    <div class="flex items-center gap-2 mb-3"><div class="w-1 h-4 bg-brand rounded-full"></div><span class="font-semibold text-gray-800">Trạng thái duyệt</span></div>
                                     <p class="my-2 flex justify-between gap-2 items-start"><span class="text-gray-500 shrink-0">TT Ký:</span> 
                                         <span class="flex flex-col gap-1 items-end">
                                             <el-tag size="mini" effect="plain" :type="isRoleSigned(row.departmentManager) ? 'success' : 'info'" class="!whitespace-normal h-auto py-0.5 px-2 text-right border-opacity-60">
                                                 {{ isRoleSigned(row.departmentManager) ? 'Trưởng bộ phận đã ký' : 'Trưởng bộ phận chưa ký' }}
                                             </el-tag>
                                             <el-tag size="mini" effect="plain" :type="isRoleSigned(row.chiefAccountant) ? 'success' : 'info'" class="!whitespace-normal h-auto py-0.5 px-2 text-right border-opacity-60">
                                                 {{ isRoleSigned(row.chiefAccountant) ? 'GĐTC đã ký' : 'GĐTC chưa ký' }}
                                             </el-tag>
                                             <el-tag size="mini" effect="plain" :type="isRoleSigned(row.reviewer) ? 'success' : 'info'" class="!whitespace-normal h-auto py-0.5 px-2 text-right border-opacity-60">
                                                 {{ isRoleSigned(row.reviewer) ? 'CEO đã ký' : 'CEO chưa ký' }}
                                             </el-tag>
                                         </span>
                                     </p>
                                    <p class="my-2 flex justify-between gap-2 items-start sm:items-center"><span class="text-gray-500 shrink-0">Trạng thái chi:</span> 
                                        <el-tag size="small" effect="plain" :type="checkPaymentStatus(row.approvePaymentStatus).type" class="rounded-lg border-opacity-50 font-semibold !whitespace-normal h-auto py-1 text-right break-words max-w-[65%]">{{ checkPaymentStatus(row.approvePaymentStatus).label }}</el-tag>
                                    </p>
                                    <p class="my-2 flex justify-between gap-2"><span class="text-gray-500 shrink-0">Ngày chi:</span> 
                                        <span class="font-medium text-gray-900 text-right break-words max-w-[65%]" v-if="row.approvePaymentDate == null">Chưa cập nhật</span>
                                        <span class="font-medium text-gray-900 text-right break-words max-w-[65%]" v-else>{{ formatPaymentDate(row.approvePaymentDate) }}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="bg-white p-4 rounded-xl border border-gray-100 shadow-sm mb-4">
                                <p class="text-sm"><span class="text-gray-500 font-semibold mb-1 block">Diễn giải:</span> <span class="text-gray-800 leading-relaxed">{{ row.interpretation }}</span></p>
                            </div>
                            <div v-if="row.rejectReason && row.rejectReason !== 'null' && row.approvePaymentStatus === 3"
                                class="w-full p-4 bg-red-50 border border-red-100 rounded-xl text-red-700 mt-4 text-sm font-medium shadow-sm flex items-start gap-2">
                                <font-awesome-icon :icon="['fas', 'circle-exclamation']" class="mt-0.5" />
                                <div>Lý do từ chối: {{ row.rejectReason }}</div>
                            </div>
                            <div class="flex flex-wrap gap-2 mt-4 items-center">
                                <el-button @click="showBillPopup(row)" size="small" type="success" plain class="shadow-sm font-semibold rounded-lg hover:-translate-y-[1px] transition-transform duration-200 !ml-0">Mở
                                    phiếu</el-button>
                                <el-button v-if="isCanUpdate(row)" @click="showUpdateBillPopup(row)" size="small"
                                    type="info" plain class="shadow-sm font-semibold rounded-lg hover:-translate-y-[1px] transition-transform duration-200 !ml-0">Cập nhật thông
                                    tin phiếu</el-button>
                                <el-button v-if="isCreator(row)" @click="createCopy(row)" size="small" type="warning"
                                    plain icon="el-icon-copy-document" class="shadow-sm font-semibold rounded-lg hover:-translate-y-[1px] transition-transform duration-200 !ml-0">Tạo bản sao
                                </el-button>
                                <el-button
                                    v-if="row.approvePaymentStatus === 0 && isDirector() || row.approvePaymentStatus === 0 && isAccountant() || row.approvePaymentStatus === 0 && isEmployee() && isAccountingDepartment()"
                                    @click="updatePaymentStatustab(row)" size="small" type="danger" plain class="shadow-sm font-semibold rounded-lg hover:-translate-y-[1px] transition-transform duration-200 !ml-0">Từ
                                    chối</el-button>
                                <el-button v-if="isCanCancel(row)" @click="showDeleteBillPopup(row.id, 'hủy')"
                                    size="small" type="danger" plain class="shadow-sm font-semibold rounded-lg hover:-translate-y-[1px] transition-transform duration-200 !ml-0">Hủy
                                    phiếu</el-button>
                                <el-button v-if="isCanDelete(row)" @click="showDeleteBillPopup(row.id, 'xóa')"
                                    size="small" type="danger" plain icon="el-icon-delete" class="shadow-sm font-semibold rounded-lg hover:-translate-y-[1px] transition-transform duration-200 !ml-0">Xóa</el-button>
                                <el-button v-if="isDirector() && row.approvePaymentStatus === 1"
                                    @click="showUpdatePayment(row.id)" size="small" type="info" class="shadow-sm font-semibold rounded-lg hover:-translate-y-[1px] transition-transform duration-200 !ml-0">Cập nhật ngày
                                    chi</el-button>
                                <button v-if="isCanAcceptPeyment(row)"
                                    @click="openAcceptPayment(row.id, row.approvePaymentDate)"
                                    class="!ml-0 mt-2 sm:mt-0 px-5 py-2 text-white text-sm font-bold rounded-lg bg-brand hover:bg-brand-light shadow-[0_4px_10px_rgba(2,75,179,0.3)] hover:-translate-y-[1px] transition-all duration-200">Xuất chi</button>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-if="$app.userInfo.user_role.value !== 3" type="selection" width="55">
                </el-table-column>
                <el-table-column prop="code" label="Mã phiếu" width="120" sortable>
                </el-table-column>
                <el-table-column min-width="120" prop="formOfBill" label="Loại phiếu">
                    <template slot-scope="{ row }">
                        {{ checkformBill(row.billType).label }}
                    </template>
                </el-table-column>
                <el-table-column prop="departments" label="Bộ phận" min-width="120" sortable>
                    <template slot-scope="{ row }">
                        {{ row.departments[0].name }}
                    </template>
                </el-table-column>
                <el-table-column min-width="150" label="Công ty">
                    <template slot-scope="{ row }">
                        {{  row.company }}
                    </template>
                </el-table-column>
                <el-table-column min-width="150" label="Cửa hàng/ Nhà cung">
                    <template slot-scope="{ row }">
                        {{ storeOrSupplier(row) }}
                    </template>
                </el-table-column>
                <el-table-column prop="createdAt" label="Ngày tạo" sortable width="120">
                    <template slot-scope="{ row }">
                        {{ formatDate(row.createdAt) }}
                    </template>
                </el-table-column>
                <el-table-column v-if="$app.fillDataNumber !== 0 && $app.fillDataNumber !== 3" prop="approvePaymentDate"
                    label="Ngày chi" sortable width="125">
                    <template slot-scope="{ row }">
                        <span v-if="row.approvePaymentDate == null">Chưa cập nhật</span><span v-else>{{
                            formatPaymentDate(row.approvePaymentDate) }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="paymentMethod" label="Phương thức" width="120">
                    <template slot-scope="{ row }">
                        <el-tag size="small" effect="plain" :type="checkPaymentMethod(row.paymentMethod).type">{{
                            checkPaymentMethod(row.paymentMethod).label }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="TT Ký" min-width="180">
                    <template slot-scope="{ row }">
                        <div class="flex flex-col gap-1 items-center justify-center py-1">
                            <el-tag size="mini" effect="plain" :type="isRoleSigned(row.departmentManager) ? 'success' : 'info'" class="!whitespace-normal h-auto py-0.5 px-2 text-center border-opacity-60">
                                {{ isRoleSigned(row.departmentManager) ? 'Trưởng bộ phận đã ký' : 'Trưởng bộ phận chưa ký' }}
                            </el-tag>
                            <el-tag size="mini" effect="plain" :type="isRoleSigned(row.chiefAccountant) ? 'success' : 'info'" class="!whitespace-normal h-auto py-0.5 px-2 text-center border-opacity-60">
                                {{ isRoleSigned(row.chiefAccountant) ? 'GĐTC đã ký' : 'GĐTC chưa ký' }}
                            </el-tag>
                            <el-tag size="mini" effect="plain" :type="isRoleSigned(row.reviewer) ? 'success' : 'info'" class="!whitespace-normal h-auto py-0.5 px-2 text-center border-opacity-60">
                                {{ isRoleSigned(row.reviewer) ? 'CEO đã ký' : 'CEO chưa ký' }}
                            </el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="Tiến độ ký" width="140">
                    <template slot-scope="{ row }">
                        <el-tag
                            v-if="row.departmentManager !== null && row.chiefAccountant !== null && row.requestingPayment !== null"
                            size="small" effect="plain" type="success">
                            Đã ký đủ
                        </el-tag>
                        <el-tag v-else size="small" effect="plain" type="danger">
                            Chưa ký đủ
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="Tổng tiền" width="120">
                    <template slot-scope="{ row }">
                        {{ formatVND(row.expense) }}
                    </template>
                </el-table-column>
                <el-table-column v-if="isAccountant() || (isEmployee() && isAccountingDepartment())"
                    column-key="reviewed" label="TT rà soát" width="124" :filters="[
                        { text: 'Đã rà soát', value: true },
                        { text: 'Chưa rà soát', value: false }
                    ]" :filter-multiple="false">
                    <template slot-scope="{ row }">
                        <div class="flex justify-center items-center">
                            <el-checkbox :value="row.reviewed" disabled />
                        </div>
                    </template>
                </el-table-column>


                <template #append>
                    <div class="p-[10px] border-t">
                        <el-pagination :current-page.sync="currentPage" :page-sizes="[10, 20, 50]" :page-size="pageSize"
                            layout="total, sizes, ->, prev, pager, next" :total="total" @size-change="onSizeChange"
                            @current-change="currChange">
                        </el-pagination>
                    </div>
                </template>
            </el-table>
        </div>
        <!-- <div v-else class=" flex justify-center font-bold">
            <div class="flex items-center text-gray-400">
                <svg class="mr-1 size-4 animate-spin ..." viewBox="0 0 24 24"><font-awesome-icon
                        :icon="['fas', 'spinner']" /></svg> Loading...
            </div>
        </div> -->
        <BillPopup v-if="isShowBill" :isShow="isShowBill" @closed="loseBillPopup" :billdetail="billdetail" />
        <DeletePopup v-if="isShowDeleteBill" :isShow="isShowDeleteBill" @closed="loseDeleteBillPopup()"
            @deletebtn="deleteBill" :deleteBillCode="deleteBillCode" :propvalue="propvalue" @updatebtn="updateStatus" />
        <UpdatePaymentStatus v-if="isShowUpdatePayment" :isShow="isShowUpdatePayment"
            @closed="closedUpdatePaymentStatus()" :propCode="propCode" />
        <AcceptPayPopup v-if="isShowAcceptPay" :isShow="isShowAcceptPay" @closed="isShowAcceptPay = false"
            :propCode="propCode" @reload="getAllBill()" />
        <NotePaymentpopup v-if="isShowEditPopup" :isShow="isShowEditPopup" @closed="isShowEditPopup = false"
            :billdetail="billdetail" :typePopup="typePopup" :nameHeader="nameHeader" @reload="reloadPage()" />
    </div>
</template>

<script>
const API_URL = process.env.VUE_APP_API_URL
const IMG_URL = process.env.VUE_APP_IMG_URL

import BillPopup from '../popup/BillPopup.vue'
import DeletePopup from '../popup/DeletePopup.vue'
import moment from 'moment'
import UpdatePaymentStatus from '../popup/UpdatePaymentStatus.vue'
import AcceptPayPopup from '../popup/AcceptPayPopup.vue'
import { getFromStorage } from "@/utils/storage";
import NotePaymentpopup from '../popup/NotePaymentpopup.vue'

export default {
    components: {
        BillPopup,
        DeletePopup,
        UpdatePaymentStatus,
        AcceptPayPopup,
        NotePaymentpopup
    },
    data() {
        return {
            urlApi: IMG_URL,
            loading: false,
            isShowBill: false,
            billdetail: null,
            selectedRow: '',
            issent: false,
            isShowDeleteBill: false,
            deleteBillCode: '',
            expandedRow: null,
            billType: '',
            currentPage: 1,
            pageSize: 10,
            total: 0,
            propvalue: '',
            isShowUpdatePayment: false,
            propCode: '',
            isShowAcceptPay: false,
            isShowEditPopup: false,
            typePopup: '',
            nameHeader: 'Cập nhật phiếu',
            multipleSelection: [],
            maxScrollLeft: 0,
            currentScrollLeft: 0,
            hasHorizontalOverflow: false,
            tableBodyWrapper: null,
            resizeObserver: null,
        }
    },
    props: {
        tablepaymentHeader: {
            type: Array,
            default: null,
        },
    },
    computed: {
        isCanUpdate() {
            return (row) => {
                if (!row || row.approvePaymentStatus === 2) return false;
                return this.isCreator(row) && this.isBillActive(row) && this.isBillNotSigned(row) && row.approvePaymentStatus !== 1 && row.reviewed === false || this.isAccountant(row) && this.isBillActive(row) || this.isEmployee(row) && this.isAccountingDepartment(row) && this.isBillActive(row) || this.isSameDepartment(row) && this.isDepartmentManager(row) && row.approvePaymentStatus !== 1 && row.reviewed === false;
            }
        },
        isCanDelete() {
            return (row) => {
                switch (row.approvePaymentStatus) {
                    case 0:
                        return this.isCreator(row) && this.isBillActive(row) && this.isBillNotSigned(row) && row.reviewed === false
                    default:
                        return false
                }
            }
        },
        isCanCancel() {
            return (row) => {
                return this.isCreator(row) && this.isBillActive(row) && this.isBillNotSigned(row) && row.approvePaymentStatus === 0 && row.reviewed === false || this.isAccountant(row) && row.approvePaymentStatus !== 2 && this.isBillActive(row) || this.isEmployee(row) && this.isAccountingDepartment(row) && row.approvePaymentStatus !== 2 && this.isBillActive(row)
            }
        },
        isCanAcceptPeyment() {
            return (row) => {
                const canAccept = this.isAccountant(row) || (this.isEmployee(row) && this.isAccountingDepartment(row));
                return canAccept && row.approvePaymentStatus === 1 && this.isBillActive(row) && this.isHasAllSignatures(row);
            }
        }
    },

    async mounted() {
        if (this.$app.token) {
            this.getAllBill()
        } else {
            this.checklogin()
        }
        this.loading = true
        this.$app.on('reloadData', (e) => this.reloadData())

        this.$nextTick(() => {
            this.initTableScrollSync();
        });
    },
    updated() {
        this.$nextTick(this.updateTableScrollDimensions);
    },
    beforeDestroy() {
        if (this.tableBodyWrapper) {
            this.tableBodyWrapper.removeEventListener('scroll', this.onBodyScroll);
        }
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
        window.removeEventListener('resize', this.updateTableScrollDimensions);
    },
    methods: {
        initTableScrollSync() {
            this.tableBodyWrapper = this.$el.querySelector('.el-table__body-wrapper');
            if (this.tableBodyWrapper) {
                this.tableBodyWrapper.addEventListener('scroll', this.onBodyScroll, { passive: true });
                this.updateTableScrollDimensions();

                if (window.ResizeObserver) {
                    this.resizeObserver = new ResizeObserver(() => {
                        this.updateTableScrollDimensions();
                    });
                    this.resizeObserver.observe(this.tableBodyWrapper);
                }
            }
            window.addEventListener('resize', this.updateTableScrollDimensions, { passive: true });
        },
        updateTableScrollDimensions() {
            if (!this.tableBodyWrapper) {
                this.tableBodyWrapper = this.$el.querySelector('.el-table__body-wrapper');
                if (this.tableBodyWrapper) {
                    this.tableBodyWrapper.addEventListener('scroll', this.onBodyScroll, { passive: true });
                }
            }
            if (this.tableBodyWrapper) {
                const scrollWidth = this.tableBodyWrapper.scrollWidth;
                const clientWidth = this.tableBodyWrapper.clientWidth;
                this.maxScrollLeft = Math.max(0, scrollWidth - clientWidth);
                this.hasHorizontalOverflow = this.maxScrollLeft > 5;
                this.currentScrollLeft = this.tableBodyWrapper.scrollLeft;
            }
        },
        onSliderInput() {
            if (this.tableBodyWrapper) {
                this.tableBodyWrapper.scrollLeft = this.currentScrollLeft;
            }
        },
        onBodyScroll() {
            if (this.tableBodyWrapper) {
                this.currentScrollLeft = this.tableBodyWrapper.scrollLeft;
            }
        },
        scrollTableLeft() {
            if (this.tableBodyWrapper) {
                this.tableBodyWrapper.scrollBy({ left: -250, behavior: 'smooth' });
            }
        },
        scrollTableRight() {
            if (this.tableBodyWrapper) {
                this.tableBodyWrapper.scrollBy({ left: 250, behavior: 'smooth' });
            }
        },
        handleFilterChange(filters) {
            if (filters.reviewed === undefined || filters.reviewed.length === 0) {
                this.$app.reviewed = null

                this.getAllBill()
            } else {
                this.$app.reviewed = filters.reviewed[0]

                this.getAllBill()
            }

            console.log('filters', this.$app.reviewed);
        },
        isCreator(row) {
            return this.$app.userInfo.email === row.authuserslog.email;
        },
        isDirector() {
            return this.$app.userInfo.user_role.value === 0;
        },

        isAccountant() {
            return this.$app.userInfo.user_role.value === 1;
        },

        isDepartmentManager() {
            return this.$app.userInfo.user_role.value === 2;
        },

        isEmployee() {
            return this.$app.userInfo.user_role.value === 3;
        },

        isAccountingDepartment() {
            return this.$app.userInfo.departments?.some(el => el.value === 3);
        },

        isSameDepartment(row) {
            return this.$app.userInfo.departments.some(
                el => el.value == row.departments[0].value
            );
        },

        isBillNotSigned(row) {
            return (
                row.departmentManager === null &&
                row.chiefAccountant === null &&
                row.reviewer === null
            );
        },

        isRoleSigned(field) {
            if (!field) return false;
            if (typeof field === 'object') {
                return field.sign === true || !!field.name;
            }
            return field === true;
        },

        isHasAllSignatures(row) {
            if (!row) return false;
            return (
                this.isRoleSigned(row.requestingPayment) &&
                this.isRoleSigned(row.departmentManager) &&
                this.isRoleSigned(row.chiefAccountant) &&
                this.isRoleSigned(row.reviewer)
            );
        },

        isBillActive(row) {
            return row.status !== 0;
        },

        tableRowClassName({ row, rowIndex }) {
            if (row.formOfBill === 1) {
                return 'success-row';
            }
            return '';
        },
        async reloadData() {
            await this.getAllBill()
        },
        storeOrSupplier(row) {
            switch (row.formOfBill) {
                case 1:
                    return row.store.shortaddress
                case 4:
                    return row.supplier
                default: ""
            }
        },
        async createCopy(row) {
            const { id, ...data } = row;
            data.code = data.code + ' (Bản sao)'
            data.status = 1
            data.chiefAccountant = null
            data.departmentManager = null
            data.reviewer = null
            data.approvePaymentStatus = 0
            data.approvePaymentDate = null
            data.attachedfile = []
            data.paytime = new Date().toISOString()
            data.createdAt = new Date().toISOString()
            data.updatedAt = new Date().toISOString()
            data.reviewed = false

            this.$confirm('Bạn muốn tạo bản sao của phiếu này?', 'Thông báo', {
                confirmButtonText: 'Đồng ý',
                cancelButtonText: 'Huỷ',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await this.$axios.post(
                        `${API_URL}/bill/createBills`,
                        { data: data },
                        { headers: { 'Content-Type': 'application/json', 'X-Authorization': `Bearer ${this.$app.token}` } }
                    );
                    if (res.data) {
                        this.$notify.success({ title: 'Thành công', message: 'Tạo phiếu thành công.' });
                        this.reloadPage()
                    }
                } catch (err) {
                    const errorMessage = err.response?.data?.error?.message || 'Đã có lỗi xảy ra';
                    this.$notify.error({ title: 'Thất bại', message: errorMessage });
                }
            }).catch(() => {
            });
        },
        filterFormBill(value, row) {
            return row.formOfBill === value;
        },
        handleSelectionChange(val) {
            this.$app.multipleSelection = val
        },
        reloadPage() {
            this.getAllBill()
        },
        showUpdateBillPopup(data) {
            if (data && data.approvePaymentStatus === 2) {
                this.$notify.warning({
                    title: 'Thông báo',
                    message: 'Không thể cập nhật phiếu ở trạng thái đã chi.'
                });
                return;
            }
            this.typePopup = 'Edit'
            this.isShowEditPopup = true
            this.billdetail = data
        },
        checkformBill(e) {
            const type = this.$app.billTypes.find(item => item.value == e)
            return type ? { label: type.label, value: type.value } : { label: 'Không xác định', value: null };
        },
        async checklogin() {
            const token = JSON.parse(getFromStorage("uToken"))
            if (token) {
                await this.$app.getUserByEmail(token).then(res => {
                    this.$app.token = token
                    this.getAllBill()
                })
            }
        },
        openAcceptPayment(id, date) {
            const now = new Date();
            if (now.toISOString().slice(0, 16) >= date) {
                this.propCode = id
                this.isShowAcceptPay = true
            } else {
                this.$notify.error({
                    title: 'Thất bại',
                    message: 'Chưa đến ngày chi.'
                });
            }
        },
        closedUpdatePaymentStatus() {
            this.isShowUpdatePayment = false
            this.$emit('reload')
        },
        showUpdatePayment(code) {
            this.propCode = code
            this.isShowUpdatePayment = true
        },
        async getAllBill() {
            this.loading = false;

            let filterData = {
                timeRange: this.$app.selectedDateRange || null,
                departmentAdmin: this.$app.departmentAdmin || null,
                fillBillAddress: this.$app.fillBillAddressValue?.storeid || null,
                formBills: this.$app.formBills || null,
                billType: this.$app.selectedBillType || null,
                approvePaymentStatus: this.$app.fillDataNumber,
                searchCode: this.$app.searchCode || null,
                checkStatus: this.$app.checkStatus || [],
                reviewed: this.$app.reviewed,
            }
            try {
                const res = await this.$axios.post(
                    `${API_URL}/bill/get-list`, filterData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "X-Authorization": `Bearer ${this.$app.token}`,
                        },
                        params: {
                            page: this.currentPage,
                            pageSize: this.pageSize,
                        },
                    }
                );

                if (res.data.success) {
                    this.$app.summary = {
                        totalPending: res.data.summary.totalPending,
                        totalApproved: res.data.summary.totalApproved,
                        totalRejected: res.data.summary.totalRejected,
                    };
                    this.$app.totalExpense = res.data.summary.totalExpense;
                    setTimeout(() => {
                        this.loading = true;
                        this.$app.listBill = res.data.data.sort((a, b) => b.id - a.id);
                        this.total = res.data.meta.pagination.total;
                    }, 300);
                }
            } catch (err) {
                console.error("❌ getAllBill error:", err);
                this.$notify.error({
                    title: "Thất bại",
                    message: "Vui lòng thử lại hoặc đăng nhập lại.",
                });
            }
        },

        async currChange(e) {
            this.currentPage = e
            this.getAllBill()
        },
        async onSizeChange(e) {
            this.pageSize = e
            this.currentPage = 1
            this.getAllBill()
        },
        checkPaymentMethod(e) {
            switch (e) {
                case '1':
                    return {
                        type: 'success',
                        label: 'Tiền mặt'
                    }
                case '2':
                    return {
                        type: 'warning',
                        label: 'Ngân hàng'
                    }
            }
        },
        checkStatus(e) {
            const status = e.status
            const chiefAccountant = e.chiefAccountant
            const departmentManager = e.departmentManager
            switch (status) {
                case 0:
                    return {
                        type: 'danger',
                        label: 'Đã hủy'
                    }
                case 1:
                    if (chiefAccountant && this.$app.userInfo.user_role.value === 1) {
                        return {
                            type: 'success',
                            label: 'Đã ký',
                        };
                    } else if (departmentManager && this.$app.userInfo.user_role.value === 2) {
                        return {
                            type: 'success',
                            label: 'Đã ký',
                        };
                    } else if (e.authuserslog.email === this.$app.userInfo.email && this.$app.userInfo.user_role.value === 3) {
                        return {
                            type: 'success',
                            label: 'Đã ký',
                        };
                    } else if (this.$app.userInfo.user_role.value === 3 && this.$app.userInfo.departments?.some(el => el.value === 3)) {
                        return {
                            type: 'warning',
                            label: 'Chờ ký',
                        };
                    } else {
                        return {
                            type: 'danger',
                            label: 'Chưa ký',
                        };
                    }
                case 2:
                    return {
                        type: 'success',
                        label: 'Đã duyệt'
                    }
                default:
                    return {
                        type: 'info',
                        label: 'Không xác định',
                    };
            }
        },

        checkPaymentStatus(e) {
            switch (e) {
                case 0:
                    return {
                        type: 'warning',
                        label: 'Chờ duyệt'
                    }
                case 1:
                    return {
                        type: 'primary',
                        label: 'Giám đốc đã duyệt'
                    }
                case 2:
                    return {
                        type: 'success',
                        label: 'Đã chi'
                    }
                case 3:
                    return {
                        type: 'danger',
                        label: 'Bị từ chối'
                    }
            }
        },
        formatDate(e) {
            return moment(e).format('DD/MM/YYYY')
        },
        formatPaymentDate(e) {
            return moment(e).format('DD/MM/YYYY')
        },
        onRowClick(row, column, event) {
            if (this.expandedRow === row.id) {
                this.expandedRow = null
                return
            }
            this.expandedRow = this.expandedRow === row.id ? null : row.id
        },
        loseDeleteBillPopup() {
            this.isShowDeleteBill = false
        },
        showDeleteBillPopup(code, value) {
            this.propvalue = value
            this.deleteBillCode = code
            this.isShowDeleteBill = true
        },
        loseBillPopup(e) {
            this.isShowBill = false
            if (e) {
                this.$emit('reload')
            }

        },
        showBillPopup(data) {
            this.isShowBill = true
            this.billdetail = data
        },
        formatVND(amount) {
            return parseInt(amount).toLocaleString("vi-VN", { style: "currency", currency: "VND" })
        },
        openDropDown(e) {
            this.selectedRow = this.selectedRow === e ? null : e;
        },
        async deleteBill(id) {
            await this.$axios.delete(`${API_URL}/bills/deleteBill/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Authorization': `Bearer ${this.$app.token}`,
                },
            }).then(res => {
                this.$emit('reload')
                this.$notify.success({
                    title: 'Thành công',
                    message: 'Xóa phiếu thành công.'
                });
            }).catch(err => {
                this.$notify.error({
                    title: 'Thất bại',
                    message: 'Xảy ra lỗi khi xóa.'
                });
            })
        },
        async updateStatus(id) {
            await this.$axios.put(`${API_URL}/bills/update/${id}`, {
                type: 'status',
                data: 0
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Authorization': `Bearer ${this.$app.token}`,
                },
            }).then(res => {
                this.$notify.success({
                    title: 'Thành công',
                    message: 'Hủy phiếu thành công.'
                });
                this.$emit('reload');
            }).catch(err => {
                this.$notify.error({
                    title: 'Thất bại',
                    message: 'Xảy ra lỗi khi hủy phiếu.'
                });
                console.log(err);
            });
        },
        async updatePaymentStatustab(row) {
            try {
                const oldReason = row.rejectReason || '';

                const { value: reason } = await this.$prompt(
                    'Bạn có thể nhập lý do từ chối',
                    'Từ chối phiếu',
                    {
                        confirmButtonText: 'Gửi',
                        cancelButtonText: 'Hủy',
                        inputPlaceholder: 'Nhập lý do (có thể bỏ trống)...',
                        inputValue: oldReason, // ⭐ GỢI Ý LÝ DO CŨ
                        inputType: 'textarea',
                        type: 'warning'
                    }
                )

                // --- Nếu bấm Đồng ý mới chạy ---
                const data = {
                    approvePaymentStatus: 3,
                    rejectReason: reason || ''
                };

                await this.$axios.put(`${API_URL}/bills/update/${row.id}`, {
                    type: 'paymentStatus',
                    data
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Authorization': `Bearer ${this.$app.token}`,
                    },
                })

                this.$notify.success({
                    title: 'Thành công',
                    message: 'Cập nhật trạng thái thành công.'
                });

                this.$emit('reload');

            } catch (err) {
                // --- Bấm Hủy ---
                if (err !== 'cancel') {
                    console.log(err)
                    this.$notify.error({
                        title: 'Thất bại',
                        message: 'Xảy ra lỗi khi cập nhật trạng thái.'
                    });
                }
            }
        }
    },
    watch: {
        '$app.fillDataNumber': {
            handler(n, o) {
                if (n != o) {
                    this.currentPage = 1
                }
            }
        }
    }
}
</script>

<style lang="scss">
.el-table {
    .custom-row-head {
        th.custom-cell-head.el-table__cell {
            background-color: #f8fafc;
            border-right: 1px solid #f1f5f9;
            border-bottom: 1px solid #e2e8f0;
            text-align: center;
            color: #475569;
            font-weight: 600;
        }
    }

    &.el-table--border {
        border: none;
        border-bottom: 1px solid #f1f5f9;
    }

    .expand-col {
        .el-table__expand-icon {
            display: none;
        }
    }

    span.el-checkbox__inner {
        height: 24px;
        width: 24px;

        &::after {
            left: 9px;
            top: 6px;
        }

        &::before {
            top: 10px !important;
        }
    }

    .el-table__body tr.current-row>td.el-table__cell {
        background-color: #efefef3b;
    }

    .el-table__body tr.current-row:hover>td.el-table__cell {
        background-color: #efefef3b;
    }

    td.el-table__cell.el-table__expanded-cell {
        border: 1px solid rgba(2, 75, 179, 0.2);
        box-shadow: inset 0 2px 8px rgba(2, 75, 179, 0.05);
        padding: 0;
    }
    
    @media (max-width: 768px) {
        .el-table__expand-column .cell {
            padding: 0 !important;
        }
        td.el-table__cell.el-table__expanded-cell {
            padding: 0 !important;
        }
    }

    .el-loading-spinner {
        i {
            color: #b1b1b1;
            font-size: 30px;
        }

        .el-loading-text {
            color: #b1b1b1;
            font-size: 18px;
        }
    }

    .success-row {
        background: #1d7ce25d;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #3b82f6 !important;
        /* tailwind: blue-500 */
        border-color: #3b82f6 !important;
    }

    /* Màu dấu tick */
    .el-checkbox__inner::after {
        border-color: white !important;
    }
}
</style>